import { render, staticRenderFns } from "./MetaCampaignEdit.vue?vue&type=template&id=cbd22a58&scoped=true"
import script from "./MetaCampaignEdit.vue?vue&type=script&lang=js"
export * from "./MetaCampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./MetaCampaignEdit.vue?vue&type=style&index=0&id=cbd22a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd22a58",
  null
  
)

export default component.exports